const generateOptions = arr =>
  arr.map(s => ({
    label: s,
    value: s,
  }));

const topics = [
  'Tax Documents',
  'Profile or Direct Deposit',
  'Pay Stubs',
  'Loan-outs',
  'W-4 / TD-1 Tax Withholding',
  'Employment Verification',
  'Product troubleshooting or support',
];

const taxDocuments = ['W-2', '1099', 'T4 or RL-1', 'T4A', 'T4A-NR or NR4'];

const years = ['Tax year 2018 or later', 'Tax year before 2018'];

const sources = ['Cast & Crew', 'CAPS or PAI', 'I don’t know'];

const canSources = ['Cast & Crew', 'I don’t know'];

const regions = ['US', 'Vancouver', 'Toronto'];

const products = ['Cast & Crew', 'CAPS / ETC (US only)', 'I don’t know'];

const crewSupportTopics = {
  topic: generateOptions(topics),
  taxDoc: generateOptions(taxDocuments),
  year: generateOptions(years),
  source: generateOptions(sources),
  canSource: generateOptions(canSources),
  region: generateOptions(regions),
  product: generateOptions(products),
};

export default crewSupportTopics;
